import Shuffle from 'shufflejs';
const productRange = document.querySelector('.productRange');
const productRangeItems = document.querySelectorAll('.productRangeItem');
const productInfo = document.querySelectorAll('.productInfo');
const filterBtns = document.querySelectorAll('.filterBtn');

if (productRange) {
	const shuffleInstance = new Shuffle(productRange, {
		itemSelector: '.productRangeItem',
		isCentered: true
	});

	// bind filter button click
	let filtersElem = document.querySelector('.filtersGroup');
	filtersElem.addEventListener('click', ( e ) => {
		let filterValue = e.target.getAttribute('data-filter');
		shuffleInstance.filter(filterValue);
	});

	filterBtns.forEach( (item) => {
		item.addEventListener('click', () => {

			filterBtns.forEach( (filterBtn) => {
				filterBtn.classList.remove('is-active');
			})

			item.classList.add('is-active');
		})
	})
}

if (productRangeItems) {

	productRangeItems.forEach( (item) => {
		item.addEventListener('click', () => {
			let infoPanel = item.dataset.info;

			productInfo.forEach( (item) => {
				item.classList.remove('is-active');
			})

			document.getElementById(infoPanel).parentElement.classList.add('is-active');

			document.getElementById(infoPanel).scrollIntoView({
				behavior: "smooth",
				block: "start",
				inline: "nearest"
			})
		})
	})
}